import fetch from 'auth/FetchInterceptor'

const subAdminsService = {}
const apiRoute = '/sub-admin';

subAdminsService.getSubAdmins = async function (query = '') {
    try {
        const res = await fetch({
            url: `${apiRoute}/getAll/admin${query}`,
            method: 'get'
        });
        return res;
    } catch (err) {
        console.log(err, 'show-err');
    }
}

subAdminsService.getSubAdminById = async function (id) {
    try {
      const res = await fetch({
        url: `${apiRoute}/getById/admin/${id}`,
        method: 'get',
      })
      return res
    } catch (err) {
      console.log(err, 'show-err')
    }
  }
  
  subAdminsService.createSubAdmin = async function (data) {
    try {
      const res = await fetch({
        url: `${apiRoute}/create/admin`,
        method: 'post',
        data: data,
      })
      return res
    } catch (err) {
      console.log(err, 'show-err')
    }
  }
  
  
  subAdminsService.editSubAdmin = async function (id, data) {
    try {
      const res = await fetch({
        url: `${apiRoute}/update/admin/${id}`,
        method: 'put',
        data: data,
      })
      return res
    } catch (err) {
      console.log(err, 'show-err')
    }
  }

  subAdminsService.resetPassword = async function (id, data) {
    try {
      const res = await fetch({
        url: `${apiRoute}/change-password`,
        method: 'post',
        data: data,
      })
      return res
    } catch (err) {
      console.log(err, 'show-err')
    }
  }

subAdminsService.delete = async function (id) {
    try {
        const res = await fetch({
            url: `${apiRoute}/delete/admin/${id}`,
            method: 'delete'
        });
        return res;
    } catch (err) {
        console.log(err, 'show-err');
    }
}

export default subAdminsService;